import { useState } from "react";

import { makeGetApiCall } from "../../shared/makeApiCall";
import ModelErrorComponent from "../../components/modals/ModelErrorComponent";

export function MixedCartonHistoryViewModel(logout) {
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });
  const [loading, setLoading] = useState(false);
  const [mixedCarton, setMixedCarton] = useState({
    barcode: null,
    order: null,
    shipped_by_name: null,
    is_returned: null,
    subtotal_price: null,
    tax_amount: null,
    total_price: null,
    created_at: null,
    barcode_histories: null,
    source_items: [],
  });

  const getMixedCartonHistory = async function (barcode) {
    if (barcode.trim().length === 0) {
      showErrorModal("Barcode cannot be empty");
      return;
    }
    setLoading(true);
    let callResult = await makeGetApiCall(`mixedCartonBarcodeHistory/${barcode}`, {});

    if (callResult.success) {
          setMixedCarton({
            barcode: callResult.data.mixed_carton.barcode,
            order: callResult.data.mixed_carton.order,
            shipped_by_name: callResult.data.mixed_carton.shipped_by_name,
            is_returned: callResult.data.mixed_carton.is_returned,
            subtotal_price: callResult.data.mixed_carton.subtotal_price,
            tax_amount: callResult.data.mixed_carton.tax_amount,
            total_price: callResult.data.mixed_carton.total_price,
            created_at: callResult.data.mixed_carton.created_at,
            barcode_histories: callResult.data.barcode_histories,
            source_items: callResult.data.mixed_carton.source_items,
          });
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message || "Mixed carton not found");
    }
    setLoading(false);
  };

  const showErrorModal = (subtitle) => {
    setEmptyModelOpen({
      childComponent: (
        <ModelErrorComponent
          setOpen={setEmptyModelOpen}
          subtitle={subtitle}
          title="Error"
        />
      ),
      open: true,
    });
  };

  return {
    mixedCarton,
    getMixedCartonHistory,
    loading,
    emptyModal,
    setEmptyModelOpen,
  };
}
